fragment srcset on AssetInterface {
    w1920: url @transform(width: 1920, immediately: false)
    w1440: url @transform(width: 1440, immediately: false)
    w1280: url @transform(width: 1280, immediately: false)
    w980: url @transform(width: 980, immediately: false)
    w768: url @transform(width: 768, immediately: false)
    w520: url @transform(width: 520, immediately: false)
    w380: url @transform(width: 380, immediately: false)

    w1920_webp: url @transform(width: 1920, immediately: false, format: "webp", quality: 84)
    w1440_webp: url @transform(width: 1440, immediately: false, format: "webp", quality: 84)
    w1280_webp: url @transform(width: 1280, immediately: false, format: "webp", quality: 84)
    w980_webp: url @transform(width: 980, immediately: false, format: "webp", quality: 84)
    w768_webp: url @transform(width: 768, immediately: false, format: "webp", quality: 84)
    w520_webp: url @transform(width: 520, immediately: false, format: "webp", quality: 84)
    w380_webp: url @transform(width: 380, immediately: false, format: "webp", quality: 84)

#    w1920_avif: url @transform(width: 1920, immediately: false, format: "avif")
#    w1440_avif: url @transform(width: 1440, immediately: false, format: "avif")
#    w1280_avif: url @transform(width: 1280, immediately: false, format: "avif")
#    w980_avif: url @transform(width: 980, immediately: false, format: "avif")
#    w768_avif: url @transform(width: 768, immediately: false, format: "avif")
#    w520_avif: url @transform(width: 520, immediately: false, format: "avif")
#    w380_avif: url @transform(width: 380, immediately: false, format: "avif")
}
